import React from "react";
import AddressInput, {
  type IFullAddressInputProps,
} from "./address/FullAddressInput";

export interface IContactAddressInputProps extends IFullAddressInputProps {}

export default (props: IContactAddressInputProps) => (
  <AddressInput {...props} isRequired={false} />
);
